import React, { useContext } from "react";
import { Grid, Typography } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import { makeStyles } from "@material-ui/core/styles";

// Contexts
import FacebookProfilesDashboardContext from "../../../context/facebook_profiles/dashboard/DashboardContext";

// Components

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: "0.8rem",
    marginLeft: "8px",
    width: "100%",
  },
  errorAlertColor: {
    backgroundColor: alpha("#ffc2b3", 0.9),
  },
}));

const DashboardError = () => {
  const classes = useStyles();

  const { selected_profile } = useContext(FacebookProfilesDashboardContext);

  return (
    <Grid container justifyContent="flex-start" alignItems="flex-start">
      <div className={classes.paper}>
        <Alert severity="error" className={classes.errorAlertColor}>
          <Typography align="justifyContent" variant="body2">
            Error Code: {selected_profile.error.code} & nbsp; - & nbsp;{" "}
            {selected_profile.error.error_subcode}{" "}
          </Typography>
          <Typography align="justifyContent" variant="body2">
            {" "}
            {selected_profile.error.message}{" "}
          </Typography>{" "}
        </Alert>{" "}
      </div>{" "}
    </Grid>
  );
};

export default DashboardError;
